import { useEffect, useState } from 'react';
import MobileTopSectionWithFilter from '@/TRC/components/TopSections/mobileTopSectionWithFilter';
import TopSectionWithFilter from '@/TRC/components/TopSections/topSectionWithFilter';
import api from '@/data/api';
import Toast from '@/utils/toastManager';
import ResourcesGrid from '@/TRC/pages/Resources/components/grid';
import TRC_PAGE_CATEGORIES from '@/TRC/constants/trcCategories';

const getCreatedAtTime = item => {
	const time = new Date(item?.createdAt || item?.updatedAt || 0).getTime();
	return Number.isNaN(time) ? 0 : time;
};

const sortNewestFirst = contents =>
	[...(contents || [])].sort((a, b) => getCreatedAtTime(b) - getCreatedAtTime(a));

const TRCResources = () => {
	const [contents, setContents] = useState();
	useEffect(() => {
		async function fetchPdf() {
			try {
				const response = await api.fetchContent({ category: TRC_PAGE_CATEGORIES.RESOURCES });

				setContents(sortNewestFirst(response?.data));
			} catch (err) {
				Toast.error(err.message || 'Something went wrong');
			}
		}
		fetchPdf();
	}, []);
	return (
		<div className="d-flex flex-column gap-2">
			<MobileTopSectionWithFilter
				contents={contents}
				setContents={setContents}
				category={TRC_PAGE_CATEGORIES.RESOURCES}
				containsPdf
			/>
			<TopSectionWithFilter setContents={setContents} contents={contents} category={TRC_PAGE_CATEGORIES.RESOURCES} containsPdf />
			<ResourcesGrid contents={contents} />
		</div>
	);
};

export default TRCResources;
